var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Colors for which there are no names in Zeplin.
//opacity 10 means that the color is having 10% of total opacity
var unnamedColors = {
    tfwBlackOpacity10: '#00000019',
    tfwBlackOpacity50: '#00000080',
    tfwBlack30: '#4d4d4d',
    tfwBlack42: '#7c7c7c',
    tfwBlack40: '#6f6f6f',
    tfwBlack91: '#282b2e',
    tfwBlack10: '#d3d3d3',
    tfwBlack99: '#282828',
    tfwBlue12: '#2298da',
    tfwBlue38: '#f7f9fb',
    tfwGrey: '#f5f5f5',
    tfwGreenOpacity08: '#75ca2b14',
    tfwOrange3: '#fff4d0',
    tfwRedOpacity08: '#e45f7514',
    tfwWhite32: '#f2f2f2',
};
// List of colors, sorted alphabetically.
var colors = __assign(__assign({}, unnamedColors), { black: '#000000', feedbackGreen: '#75ca2b', feedbackGreen20: '#e3f4d5', datepickerBlue: '#2298da', tfwBeige: '#c4b485', tfwBlack3: '#f7f7f7', tfwBlack12: '#e0e0e0', tfwBlack38: '#9e9e9e', tfwBlack45: '#757575', tfwBlack87: '#212121', tfwBlue: '#64b6e7', tfwBlueHover: '#a0d8f4', tfwBlueLighter: '#edf7fc', tfwDefaultInputBorder: '#dddddd', tfwErrorBackground: '#fadfe3', tfwErrorRed: '#af0d21', tfwGreen: '#75912b', tfwGreenHover: '#b1c689', tfwOrange: '#e74011', tfwOrangeHover: '#ff957d', tfwPurple: '#6a476a', tfwPurpleHover: '#b39bb0', tfwRed: '#e45f75', tfwRedHover: '#fca6b5', tfwWarning: '#9d5000', tfwWarningBackground: '#fff3cc', tfwWarningBorder: '#fee799', tfwWhite64: '#f8f8f8', tfwWhite85: '#ffffffd9', tfwYellow: '#fdc400', tfwYellow10: '#fef9e5', tfwYellowHover: '#fedc66', white: '#ffffff', tfwNegativeMedium: '#be4305', tfwPositiveMedium: '#007150', tfwAlertMedium: '#9e6c00', tfwPositiveBackground: '#ebfff8', tfwPremiumMedium: '#6b44a5', tfwPremiumBackground: '#f9f5ff', tfwHyperLink: '#006DDB' });
export default colors;
